import {
    GET_QUESTIONS,
    GET_QUESTIONS_SUCCESS,
    GET_QUESTIONS_FAILURE,
    UPDATE_QUESTION_STATUS,
    UPDATE_QUESTION_STATUS_SUCCESS,
    UPDATE_QUESTION_STATUS_FAILURE,
    DELETE_QUESTION,
    DELETE_QUESTION_SUCCESS,
    DELETE_QUESTION_FAILURE,
    ADD_QUESTION,
    ADD_QUESTION_SUCCESS,
    ADD_QUESTION_FAILURE,
    GET_QUESTION_DETAILS,
    GET_QUESTION_DETAILS_SUCCESS,
    GET_QUESTION_DETAILS_FAILURE,
    IMPORT_QUESTIONS_DATA,
    IMPORT_QUESTIONS_DATA_SUCCESS,
    IMPORT_QUESTIONS_DATA_FAILURE,
    EDIT_QUESTION,
    EDIT_QUESTION_SUCCESS,
    EDIT_QUESTION_FAILURE
} from "../Constants"

const init = {
    data: {},
    update_data: {},
    delete_data: {},
    add_data: {},
    edit_data: {}
};

const QuestionReducer = (state = init, action) => {
    switch (action.type) {
        case GET_QUESTIONS:
            return { ...state, loading: true };
        case GET_QUESTIONS_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_QUESTIONS_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case EDIT_QUESTION:
            return { ...state, loading: true };
        case EDIT_QUESTION_SUCCESS:
            return { ...state, loading: false, edit_data: action.payload };
        case EDIT_QUESTION_FAILURE:
            return { ...state, loading: false, edit_data: action.payload };
        case UPDATE_QUESTION_STATUS:
            return { ...state, loading: true };
        case UPDATE_QUESTION_STATUS_SUCCESS:
            return { ...state, loading: false, update_data: action.payload };
        case UPDATE_QUESTION_STATUS_FAILURE:
            return { ...state, loading: false, update_data: action.payload };
        case DELETE_QUESTION:
            return { ...state, loading: true };
        case DELETE_QUESTION_SUCCESS:
            return { ...state, loading: false, delete_data: action.payload };
        case DELETE_QUESTION_FAILURE:
            return { ...state, loading: false, delete_data: action.payload };
        case ADD_QUESTION:
            return { ...state, loading: true };
        case ADD_QUESTION_SUCCESS:
            return { ...state, loading: false, add_data: action.payload };
        case ADD_QUESTION_FAILURE:
            return { ...state, loading: false, add_data: action.payload };
        case GET_QUESTION_DETAILS:
            return { ...state, loading: true };
        case GET_QUESTION_DETAILS_SUCCESS:
            return { ...state, loading: false, details_data: action.payload };
        case GET_QUESTION_DETAILS_FAILURE:
            return { ...state, loading: false, details_data: action.payload };
        case IMPORT_QUESTIONS_DATA:
            return { ...state, loading: true };
        case IMPORT_QUESTIONS_DATA_SUCCESS:
            return { ...state, loading: false, import_data: action.payload };
        case IMPORT_QUESTIONS_DATA_FAILURE:
            return { ...state, loading: false, import_data: action.payload };
        default:
            return state;
    }
};

export default QuestionReducer;